import { render, staticRenderFns } from "./InfoProducto.vue?vue&type=template&id=43cc0aaf&scoped=true"
import script from "./InfoProducto.vue?vue&type=script&lang=js"
export * from "./InfoProducto.vue?vue&type=script&lang=js"
import style0 from "./InfoProducto.vue?vue&type=style&index=0&id=43cc0aaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cc0aaf",
  null
  
)

export default component.exports